import axios from 'axios';

export function getCargoNamesAutocomplete(name) {
    return axios({
        method: 'POST',
        url: '/api/v1/cargo/findCargoAdminPanel',
        data: {
            name,
        },
        withCredentials: true,
    });
}

export function getCargoRealNames() {
    return axios({
        method: 'GET',
        url: '/api/v1/cargoassigner/cargo/names',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function updateCargoRealName(item) {
    return axios({
        method: 'PUT',
        url: `/api/v1/cargoassigner/cargo/${item._id}`,
        withCredentials: true,
        data: {
            CargoCategory: item.parent.red._id,
            CargoCategoryName: item.parent.red.name,
            realCargoName: item.name,
            details: item.details ? item.details : '',
        },
    }) // todo sending response.data
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function checkForDeleteCargoName(item) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/cargoassigner/cargo/${item._id}`,
        withCredentials: true,
    });
}

export function deleteCargoRealName(item) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/cargoassigner/cargo/${item._id}?force=true`,
        withCredentials: true,
    })// todo sending response.data
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getTagsCategories() {
    return axios({
        method: 'GET',
        url: '/api/v2/tags/categories?entity=cargoRequest',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function addTagsCategories(value, description) {
    return axios({
        method: 'POST',
        url: '/api/v2/tags/categories?entity=cargoRequest',
        withCredentials: true,
        data: {
            value,
            description,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function addTag(value, categoryName) {
    return axios({
        method: 'POST',
        url: '/api/v2/tags/tags/system?entity=cargoRequest',
        withCredentials: true,
        data: {
            value,
            categoryName,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function searchTags(query, category = '') {
    return axios({
        method: 'GET',
        url: `/api/v2/tags/tags?entity=cargoRequest&category=${category}&q=${query}`,
        withCredentials: true,
    })
        .then(response => response.data.data.map(item => ({
            ...item,
            id: item._id,
            name: item.value,
        })))
        .catch(response => response.response.data);
}

export function saveTags(cargoId, tags) {
    return axios({
        method: 'PUT',
        url: `/api/v1/cargo/${cargoId}/tags`,
        data: {
            tags,
        },
    });
}

/**
 * @param {{ page: number, limit: number, filters?: { search?: string } }} param0
 */
export function getCargoRealNamesPaginated({
    page, limit, filters = {},
}) {
    return axios({
        method: 'post',
        url: '/api/v2/adminPanel/realCargoNames',
        withCredentials: true,
        data: {
            page, limit, filters,
        },
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/cargoes/realNames.js